module.exports = __webpack_public_path__ + "img/investment.ada99d3d.svg";